"use client";

import classNames from "classnames";
import type { ReactNode } from "react";
import styles from "./DrawerFooter.module.scss";

type DrawerFooterProps = {
  children: ReactNode;
  className?: string;
};

export const DrawerFooter = ({ children, className }: DrawerFooterProps) => {
  return (
    <footer className={classNames(styles["comp"], className)}>{children}</footer>
  );
};
